import InactiveDialog from './InactiveDialog'

export default InactiveDialog
